import { render, staticRenderFns } from "./ColorBadge.vue?vue&type=template&id=905513de&"
import script from "./ColorBadge.vue?vue&type=script&lang=js&"
export * from "./ColorBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports